const {createContext} = require("react");

const {Provider, Consumer} = createContext();

exports.ModalProvider = Provider;
exports.ModalConsumer = Consumer;
